export default __webpack_public_path__ + "static/facetime-6239d05fdcb05e02d7353cc112ba71d5.png";